import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ovh = defineConnector({
  identifier: "ovh",
  name: "OVHcloud",
  tagLine: "European cloud infrastructure provider",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () =>
    "https://(?:[^/]*\\.api\\.ovh\\.com/.*|api\\.ovh\\.com/.*)",
  auth: customAuth("ovh"),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [OVHcloud API](https://api.ovh.com/createToken/) to create API credentials.",
        },
        {
          kind: "input",
          label: "Application key",
          required: true,
          target: { kind: "secrets", field: "appKey" },
        },
        {
          kind: "input",
          label: "Application secret",
          required: true,
          target: { kind: "secrets", field: "appSecret" },
        },
        {
          kind: "input",
          label: "Consumer key",
          required: true,
          target: { kind: "secrets", field: "consumerKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://eu.api.ovh.com/1.0/me",
  },
});
